import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const BrowserVideoIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-browserVideo"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M52,0 L16,0 C14.3427153,0 13,1.34271525 13,3 L13,31 C13,32.6572847 14.3427153,34 16,34 L52,34 C53.6572847,34 55,32.6572847 55,31 L55,3 C55,1.34271525 53.6572847,0 52,0 Z M16,2 L52,2 C52.5527153,2 53,2.44728475 53,3 L53,31 C53,31.5527153 52.5527153,32 52,32 L16,32 C15.4472847,32 15,31.5527153 15,31 L15,3 C15,2.44728475 15.4472847,2 16,2 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M18 4C18 4.552 17.552 5 17 5 16.448 5 16 4.552 16 4 16 3.448 16.448 3 17 3 17.552 3 18 3.448 18 4M50.0741 4.9259 26.9261 4.9259C26.4141 4.9259 26.0001 4.5109 26.0001 3.9999L26.0001 3.9999C26.0001 3.4889 26.4141 3.0739 26.9261 3.0739L50.0741 3.0739C50.5851 3.0739 51.0001 3.4889 51.0001 3.9999L51.0001 3.9999C51.0001 4.5109 50.5851 4.9259 50.0741 4.9259"
          fill="#00000"
          className={styles.defaultColor}
        />
        <polygon fill="#00000" className={styles.defaultColor} points="15 7 53 7 53 6 15 6" />
        <path
          d="M21 4C21 4.552 20.552 5 20 5 19.448 5 19 4.552 19 4 19 3.448 19.448 3 20 3 20.552 3 21 3.448 21 4M24 4C24 4.552 23.552 5 23 5 22.448 5 22 4.552 22 4 22 3.448 22.448 3 23 3 23.552 3 24 3.448 24 4"
          fill="#00000"
          className={styles.defaultColor}
        />
        <path
          d="M38.604,19.726 L35.367,21.806 L32.13,23.887 C31.628,24.209 31,23.806 31,23.16 L31,19 L31,14.84 C31,14.194 31.628,13.791 32.13,14.114 L35.367,16.194 L38.604,18.274 C39.132,18.613 39.132,19.387 38.604,19.726 L38.604,19.726 Z M18,28 L50,28 L50,10 L18,10 L18,28 Z"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
      </g>
    </Icon>
  )
}
